import React from "react";
import "./Card.css"; // Optional: Import styles if needed

const cardData = [
  { title: "Cloud-native expertise", description: "Our team specializes in building applications optimized for the cloud, ensuring seamless integration and high performance across all platforms." },
  { title: "Proven DevOps strategies", description: "We help you automate workflows, accelerate deployment cycles, and maintain stability in your infrastructure with best-in-class DevOps tools and practices" },
  { title: "End-to-end cloud migration", description: "From planning to execution, we guide your entire cloud migration journey with minimal disruption, ensuring data integrity and a seamless transition." },
  { title: "Data-driven insights", description: "Make smarter decisions with actionable insights. We help you harness data analytics and machine learning to uncover trends and optimize processes." },
];

function Card() {
    return (
      <div className="cards-section">
        <div className="cards-container">
          {cardData.map((card, index) => (
            <div key={index} className="card">
              <p className="card-title">{card.title}</p>
              <p className="small-desc">{card.description}</p>
              <div className="go-corner">
                <div className="go-arrow">→</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
  

export default Card;